import { apps } from '../../../apps'

// Flattens every 'webhook'-enabled app's declared webhook scopes into a single list, so
// an app can register more than one independently-configured webhook (e.g. a sub-app
// inside it) by naming its extra scopes 'appName.subApp'. An app that doesn't declare
// `webhookScopes` gets its implicit single default scope (own app.name) — today's
// one-webhook-per-app behavior, unchanged for every existing app.
export const getAllWebhookScopeDefs = () => Object.values(apps)
  .filter(a => a && a.name && Array.isArray(a.appConfig) && a.appConfig.includes('webhook'))
  .flatMap(a => (Array.isArray(a.webhookScopes) && a.webhookScopes.length
    ? a.webhookScopes
    : [{ scope: a.name, label: a.displayName }]
  ).map(s => ({ ...s, appName: a.name, appDisplayName: a.displayName })))

// Human-readable label for a stored scope string: just the app's display name for its
// own default scope, "App — label" for a sub-scope, or the raw scope as a fallback (e.g.
// a stale config row left behind after an app/scope was renamed or removed).
export const getWebhookScopeLabel = (scope) => {
  const def = getAllWebhookScopeDefs().find(d => d.scope === scope)
  if (!def) return scope
  return def.scope === def.appName ? def.appDisplayName : `${def.appDisplayName} — ${def.label}`
}
